import { render } from "./CCTVModule.vue?vue&type=template&id=8c3f6090&scoped=true"
import script from "./CCTVModule.vue?vue&type=script&lang=js"
export * from "./CCTVModule.vue?vue&type=script&lang=js"

import "./CCTVModule.vue?vue&type=style&index=0&id=8c3f6090&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c3f6090"

export default script